module.exports = __webpack_public_path__ + "static/media/lhfsp.3f5ff998.png";